import type { TradeInTrackingParamsType } from "../utils/tracking";
import { useTradeInAemSelector } from "../redux/store";
import { useTradeInCsl } from "../csl/tradeInCslUtils";

const useTrackingParams = (): TradeInTrackingParamsType => {
    const csl = useTradeInCsl();
    const dealer = useTradeInAemSelector((state) => state.tradeInAemDealer.dealer);
    const tradeInVersion = useTradeInAemSelector((state) => state.tradeInAemUtils.version);
    const parentComponent = useTradeInAemSelector((state) => state.tradeInAemUtils.parentComponent);

    return {
        csl,
        dealer,
        tradeInVersion,
        parentComponent,
    };
};

export default useTrackingParams;
